import { AlgoliaFacetCountsResponseModel } from "../../data-model/algoliaFacetCountsResponseModel";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export interface GetFacetsCountFromAlgoliaOnMasterAuthStatusParams {
  org_id: string;
  facet_attribute: string;
  assigned_to: string;
}

export const getFacetsCountFromAlgoliaOnMasterAuthStatus = async (
  params: GetFacetsCountFromAlgoliaOnMasterAuthStatusParams,
): Promise<AlgoliaFacetCountsResponseModel> => {
  const bearerToken = await getBearerToken();

  const raw = JSON.stringify({
    org_id: params.org_id,
    facet_attribute: params.facet_attribute,
    assigned_to: params.assigned_to,
  });

  const requestOptions: RequestInit = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearerToken}`,
    },
    body: raw,
  };

  try {
    const response = await fetch(
      API_ENDPOINTS.ALGOLIA_MULTI_FACET_COUNTS,
      requestOptions,
    );
    const result = await response.json();
    return result as AlgoliaFacetCountsResponseModel;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
